"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var api = _interopRequireWildcard(require("@/api/ordertimelimitconfig.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "Dict",
  dicts: [],
  components: {},
  data: function data() {
    var _this = this;
    return {
      isLoading: false,
      visible: false,
      tinymceRenderFlag: true,
      tinymceKey: 0,
      dataForm: {
        id: 0,
        // 补充id字段，确保编辑时能正确赋值
        startTime: '',
        // 改为空字符串，适配时间选择器的默认值
        endTime: '' // 改为空字符串，适配时间选择器的默认值
      },
      standardRangeConfig: {},
      dataRule: {
        // 可根据需要添加时间格式校验规则
        startTime: [
          // { required: true, message: '请选择开始时间', trigger: 'change' } // 如需必填可开启
        ],
        endTime: [
        // { required: true, message: '请选择结束时间', trigger: 'change' }, // 如需必填可开启
        {
          validator: function validator(rule, value, callback) {
            // 自定义校验：结束时间不能早于开始时间
            if (value && _this.dataForm.startTime && value < _this.dataForm.startTime) {
              callback(new Error('结束时间不能早于开始时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      },
      multiSelectFields: [],
      singleSelectFields: [],
      switchFields: [],
      tinymceFields: []
    };
  },
  methods: {
    resetTinymceFields: function resetTinymceFields() {
      var _this2 = this;
      this.tinymceFields.forEach(function (field) {
        _this2.dataForm[field] = '';
        _this2.$forceUpdate();
      });
      this.tinymceKey += 1;
    },
    handleDialogClose: function handleDialogClose() {
      this.tinymceRenderFlag = false;
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate();
      }
      // 清空标准范围临时变量
      for (var tempVarName in this.standardRangeConfig) {
        this[tempVarName] = null;
      }
      // 重置时间选择器的值
      this.dataForm.startTime = '';
      this.dataForm.endTime = '';
    },
    transformMultiSelectToArr: function transformMultiSelectToArr(formData) {
      this.multiSelectFields.forEach(function (field) {
        if (formData[field] && typeof formData[field] === 'string') {
          formData[field] = formData[field].split(',').filter(function (item) {
            return item.trim();
          });
        } else if (!formData[field]) {
          formData[field] = [];
        }
      });
      return formData;
    },
    transformSingleSelectToStr: function transformSingleSelectToStr(formData) {
      this.singleSelectFields.forEach(function (field) {
        if (formData[field] !== undefined && formData[field] !== null) {
          formData[field] = String(formData[field]);
        } else {
          formData[field] = '';
        }
      });
      return formData;
    },
    transformSwitchToStr: function transformSwitchToStr(formData) {
      this.switchFields.forEach(function (field) {
        if (formData[field] !== undefined && formData[field] !== null) {
          formData[field] = String(formData[field]);
        } else {
          formData[field] = '0';
        }
      });
      return formData;
    },
    transformMultiSelectToStr: function transformMultiSelectToStr(formData) {
      var submitData = _objectSpread({}, formData);
      this.multiSelectFields.forEach(function (field) {
        if (Array.isArray(submitData[field])) {
          submitData[field] = submitData[field].join(',');
        }
      });
      return submitData;
    },
    init: function init(id) {
      var _this3 = this;
      this.tinymceRenderFlag = true;
      this.isLoading = false;
      this.dataForm.id = id || 0;
      this.visible = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].resetFields();

        // 初始化标准范围临时变量
        for (var tempVarName in _this3.standardRangeConfig) {
          _this3[tempVarName] = null;
        }
        if (_this3.dataForm.id === 0) {
          // 新增时重置时间值
          _this3.dataForm.startTime = '';
          _this3.dataForm.endTime = '';
          _this3.tinymceFields.forEach(function (field) {
            _this3.dataForm[field] = '';
          });
          _this3.tinymceKey += 1;
        } else {
          // 编辑时回显时间数据（接口返回字符串格式）
          api.ordertimelimitconfigDetailApi(id).then(function (res) {
            res = _this3.transformSwitchToStr(res);
            res = _this3.transformSingleSelectToStr(res);
            _this3.dataForm = _this3.transformMultiSelectToArr(res);
            // 确保时间字段是字符串格式，适配时间选择器回显
            if (_this3.dataForm.startTime === null) _this3.dataForm.startTime = '';
            if (_this3.dataForm.endTime === null) _this3.dataForm.endTime = '';
            _this3.tinymceKey += 1;
            _this3.initStandardRangeTempVars();
          });
        }
      });
    },
    dataSubmit: function dataSubmit() {
      var _this4 = this;
      if (this.isLoading) {
        console.log('loading...');
        return;
      }
      this.isLoading = true;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var submitData = _this4.transformMultiSelectToStr(_this4.dataForm);
          // 提交的时间数据已是字符串格式，无需额外转换

          if (_this4.dataForm.id) {
            api.ordertimelimitconfigUpdateApi(submitData).then(function (res) {
              _this4.visible = false;
              _this4.$message.success('修改成功!');
              _this4.$emit('refreshDataList');
            }).catch(function (e) {
              _this4.isLoading = false;
            });
          } else {
            api.ordertimelimitconfigCreateApi(submitData).then(function (res) {
              _this4.visible = false;
              _this4.$message.success('添加成功!');
              _this4.$emit('refreshDataList');
            }).catch(function (e) {
              _this4.isLoading = false;
            });
          }
        } else {
          _this4.isLoading = false;
        }
      });
    },
    // 引入范围相关方法
    handleStandardRangeChange: function handleStandardRangeChange(startField, endField, value) {
      if (Array.isArray(value) && value.length === 2) {
        this.dataForm[startField] = value[0];
        this.dataForm[endField] = value[1];
      } else {
        this.dataForm[startField] = null;
        this.dataForm[endField] = null;
      }
    },
    initStandardRangeTempVars: function initStandardRangeTempVars() {
      for (var tempVarName in this.standardRangeConfig) {
        var config = this.standardRangeConfig[tempVarName];
        var startField = config.startField;
        var endField = config.endField;
        var startValue = this.dataForm[startField];
        var endValue = this.dataForm[endField];
        if (startValue && endValue) {
          this[tempVarName] = [startValue, endValue];
        } else {
          this[tempVarName] = null;
        }
      }
    }
  }
};